// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Spgq","rightAdornment":"Header_rightAdornment__32y6t"};